import { atom } from "recoil";

export const activateIdleTimer = atom({
  key: "activateIdleTimer",
  default: true,
});